<!-- `.mtoast` (P/Member_Hub.html:954-955): the message, then the action as a 44 px target. -->
<div class="agu-toast" [class.agu-toast--show]="State.Visible" [class.agu-toast--detail]="Detail" [class.agu-toast--tabs-hidden]="TabsHidden && !Detail" role="status" aria-live="polite" aria-atomic="true">
    <span class="agu-toast__text">{{ State.Text }}</span>
    @if (State.Action) {
        <button type="button" class="agu-toast__action" (click)="RunAction()">{{ State.Action.Label }}</button>
    }
</div>
